import { useState, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export function useJobDetailsPanel() {
  const [selectedJobId, setSelectedJobId] = useState(null);
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Open the job details panel
  const openJobDetails = useCallback((jobId) => {
    setSelectedJobId(jobId);
    setIsPanelOpen(true);
    
    // Update URL without navigation to maintain browser history for sharing
    // This allows the share button to work with the correct URL
    const newUrl = `${location.pathname}?jobId=${jobId}`;
    window.history.pushState({ jobId }, '', newUrl);
  }, [location.pathname]);

  // Close the job details panel
  const closeJobDetails = useCallback(() => {
    setIsPanelOpen(false);
    setSelectedJobId(null);
    
    // Restore original URL
    window.history.pushState({}, '', location.pathname);
  }, [location.pathname]);

  // Handle browser back button
  const handleBrowserNavigation = useCallback((event) => {
    if (event.state?.jobId) {
      setSelectedJobId(event.state.jobId);
      setIsPanelOpen(true);
    } else {
      setIsPanelOpen(false);
      setSelectedJobId(null);
    }
  }, []);

  return {
    selectedJobId,
    isPanelOpen,
    openJobDetails,
    closeJobDetails,
    handleBrowserNavigation
  };
} 